<span [ngClass]="[variant || '', size || '']">
  <mat-icon *ngIf="icon" [class]="icon"></mat-icon>
  {{ label || '' }}
</span>